// src/AuthPopup.js


// src/AuthPopup.js
import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom'; // Import useNavigate hook
import { useLocation } from 'react-router-dom';
import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import { auth } from './firebase';
import Banner from './Banner'; // Import the Banner component
import { useMediaQuery } from 'react-responsive';
import './BetaSignupPopup.css';
import PrimaryButton from './PrimaryButton';
import { db } from './firebase'; // Import your Firestore instance
import { collection, addDoc } from 'firebase/firestore';
import ReactPixel from 'react-facebook-pixel';
import { v4 as uuidv4 } from 'uuid'; // Import UUID generator





function BetaSignupPopup({ isVisible, onClose }) {
  const popupRef = useRef(null);
  const [message, setMessage] = useState(''); // State for error messages
  const [showMessage, setShowMessage] = useState(false); // State to control banner visibility
  const navigate = useNavigate(); // Hook to programmatically navigate
  const location = useLocation();
  const langPrefix = location.pathname.split('/')[1] || 'en';
  const isDesktop = useMediaQuery({ minWidth: 1024 });
  const [submitted, setSubmitted] = useState(false); // State to control banner visibility


  const [name, setName] = useState('New User')
  const [city, setCity] = useState('Beta')
  const [email, setEmail] = useState('')

  const messages = {
    nl: "Email in gebruik. Controleer uw spamfolder.",
    en: "Email already in use. Check your email spam folder.",
    fr: "E-mail déjà utilisé. Vérifiez votre dossier spam."
  };

  const available = {
    nl: "🎉 Nu beschikbaar!",
    en: "🎉 Now available!",
    fr: "🎉 C'est disponible!"
  };





  const submitRegistration = async (e) => {

    let dotCount = 0;
    const dots = ['.', '..', '...'];
    const eventId = uuidv4();

    // Start a timer to cycle through the dots
    const interval = setInterval(() => {
      dotCount = (dotCount + 1) % dots.length; // Cycle between 0, 1, 2
      setMessage(`Submitting${dots[dotCount]}`);
    }, 500); // Update every 500ms

    try {
      const docRef = await addDoc(collection(db, 'betaSignups'), {
        email: email,
        timestamp: new Date(),
        name: name,
        city: city,
      });
      console.log('Document written with ID: ', docRef.id);
      setShowMessage(true)
    } catch (e) {
      console.error('Error adding document: ', e);
    }

    const response = await fetch('https://jointly-api-274980191481.europe-west1.run.app/api/subscribe', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        first_name: name,
        email: email,
        event_id: eventId,
      }),
    });

    const data = await response.json();

    console.log(data)

    if (!response.ok || (data.status === 500)) {
      console.error('Failed to add subscriber to email sequence')
      clearInterval(interval);
      setMessage('');
      setEmail("")
    } else if (data.status === 201) {
      console.log('Already subscribed');
      clearInterval(interval);
      setMessage(messages[langPrefix] || messages['en']);
    } else if (data.status === 200) {
      console.log('Kit ok');
      clearInterval(interval);
      setSubmitted(true)
      window.fbq('track', 'Contact', {}, {
        'eventID': eventId
      })

      // ReactPixel.track('CompleteRegistration', {
      //   eventID: eventId,
      // },
      // {
      //   eventID: eventId,
      // });
      setEmail("")
    }
  };


  useEffect(() => {

    if (isVisible) {

      const handleEscape = (event) => {
        if (event.key === 'Escape') {
          onClose();
        }
      };
      document.addEventListener('keydown', handleEscape);

      return () => {
        document.removeEventListener('keydown', handleEscape);
      };
    }
  }, [isVisible, onClose]);

  const handleOutsideClick = (event) => {
    if (popupRef.current && !popupRef.current.contains(event.target)) {
      onClose();
    }
  };

  const betaDescTexts = {
    nl: "Download de app gratis, ontdek leuke activiteiten, ontmoet nieuwe mensen en word deel van onze groeiende community.",
    en: "Download the app for free today to discover fun activities, to meet new people and to be part of our growing community.",
    fr: "Téléchargez l’application gratuitement, découvrez des activités et rencontrez de nouvelles personnes."
  };

  const updateTexts = {
    nl: "Of blijf op de hoogte van updates:",
    en: "Or stay in the loop with updates:",
    fr: "Ou restez informé des nouveautés:"
  };

  const thankYouTexts = {
    nl: "Bedankt voor het aanmelden. We hebben je info ontvangen en je ontvangt zodra een e-mail. Controleer ook je spammap.",
    en: "Thanks for joining our community. Your info has been submitted and you'll receive an email soon. Check your spam as well.",
    fr: "Merci de vous être inscrit. Nous avons bien reçu vos informations et vous recevrez bientôt un e-mail. Vérifiez également votre dossier spam."
  };

  const welcomeTexts = {
    nl: "Welkom bij Jointly!",
    en: "Welcome to Jointly!",
    fr: "Bienvenue chez Jointly !"
  };

  return (
    <>
      {isVisible && (<div className="overlay" onClick={handleOutsideClick}>
        <div className="popup" ref={popupRef}>
          <button className="close-button" onClick={onClose}>X</button>
          <div className='beta-content-container'>




            {!submitted && (
              <>
                <div className='beta-header-cont'>
                  <h3 className="beta-header-text">{available[langPrefix] || available['en']}</h3>
                </div>

                <div className='beta-desc-cont'>
                  <p className="beta-desc-text">{betaDescTexts[langPrefix] || betaDescTexts['en']}</p>
                </div>

                <div className='beta-store-banners'>
                  <a href="https://apps.apple.com/be/app/jointlybe/id6741575789" target="_blank" rel="noopener noreferrer" className="beta-aas-wrapper" >
                    <img src='/assets/AppleAppStore_EN.svg' alt="Registrated" className="beta-aas" />
                  </a>
                  <a href="https://play.google.com/store/apps/details?id=com.joinjointly.jointlyapp" target="_blank" rel="noopener noreferrer" className="beta-gps-wrapper" >
                    <img src='/assets/GooglePlayStore_EN.png' alt="Registrated" className="beta-aas" />
                  </a>
                </div>




                <div className='beta-desc-cont2'>
                  <p className="beta-desc-text">{updateTexts[langPrefix] || updateTexts['en']}</p>
                </div>

                <div className="beta-email-cont">
                  <input
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="Email*"
                    className='beta-email-form'
                  />
                </div>
                <div className="beta-disc-cont">
                  <p className='beta-disc-text'>No spam. Unsubscribe at any time.</p>
                </div>

                <div className="beta-button-cont">
                  <PrimaryButton text="Join Jointly" width="100%" height="100%" borderRadius={"8px"} onLoginClick={submitRegistration} />
                </div>
                {showMessage && (
                  <div className="beta-message-cont">
                    <p className='beta-message-text'>{message}</p>
                  </div>)}
              </>
            )
            }

            {submitted && (
              <>
                <div className='beta-subheader-cont'>
                  <h3 className="beta-subheader-text">{welcomeTexts[langPrefix] || welcomeTexts['en']}</h3>
                </div>

                <div className='beta-subdesc-cont'>
                  <p className="beta-subdesc-text">{thankYouTexts[langPrefix] || thankYouTexts['en']}</p>
                </div>

                <div className="beta-check-cont">
                  <img src='/assets/blue_check.png' alt="Registrated" className="beta-check" />
                </div>
              </>
            )
            }

          </div>
        </div>
      </div>)}
    </>
  );
}

export default BetaSignupPopup;

